import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
  Divider,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

const InvoiceEditorDialog = ({ open, initialValue, onSave, onClose }) => {
  const [invoiceFields, setInvoiceFields] = useState([]);
  const [newInvoiceCount, setNewInvoiceCount] = useState(1);

  useEffect(() => {
    if (open) {
      const split = initialValue
        ? initialValue.split(/\s*,\s*/).filter((s) => s.trim() !== "")
        : [];
      setInvoiceFields(split);
      setNewInvoiceCount(1);
    }
  }, [open, initialValue]);

  const handleInvoiceFieldChange = (index, value) => {
    const updated = [...invoiceFields];
    updated[index] = value;
    setInvoiceFields(updated);
  };

  const handleRemoveInvoice = (index) => {
    setInvoiceFields((prev) => prev.filter((_, i) => i !== index));
  };

  const handleNewInvoiceCountChange = (e) => {
    const val = parseInt(e.target.value, 10);
    setNewInvoiceCount(isNaN(val) || val < 1 ? 1 : val);
  };

  const handleGenerateNewInvoices = () => {
    setInvoiceFields((prev) => [...prev, ...Array(newInvoiceCount).fill("")]);
    setNewInvoiceCount(1);
  };

  const handleSave = () => {
    const nonEmpty = invoiceFields.map((s) => s.trim()).filter(Boolean);
    onSave(nonEmpty.join(", "));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edytuj numery faktur</DialogTitle>
      <DialogContent dividers>
        {invoiceFields.map((invoice, idx) => (
          <Box key={idx} display="flex" alignItems="center" marginBottom={2}>
            <TextField
              label={`Faktura ${idx + 1}`}
              variant="outlined"
              fullWidth
              value={invoice}
              onChange={(e) => handleInvoiceFieldChange(idx, e.target.value)}
            />
            <IconButton
              aria-label="Usuń fakturę"
              onClick={() => handleRemoveInvoice(idx)}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}

        <Divider style={{ margin: "16px 0" }} />

        <Box display="flex" alignItems="center" marginBottom={2}>
          <TextField
            label="Ile nowych faktur dodać?"
            type="number"
            value={newInvoiceCount}
            onChange={handleNewInvoiceCountChange}
            inputProps={{ min: 1 }}
            style={{ marginRight: 16, width: 120 }}
            variant="outlined"
          />
          <Button
            variant="contained"
            onClick={handleGenerateNewInvoices}
            disabled={!newInvoiceCount}
          >
            Dodaj
          </Button>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleSave} color="primary">
          Zapisz
        </Button>
        <Button onClick={onClose} color="secondary">
          Anuluj
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceEditorDialog;
